import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../actions/actions';
import PetCard from './PetCard';
import { FormCardGroup, Form } from '../Helpers/Form';
import Storage from '../Helpers/Storage/Storage';

class Pets extends Component {
  constructor(props) {
    super(props);
    props.getPets();
  }
  render() {
    const { petsVm } = this.props;
    return (
      <div className="pets">
        <section className="petOverview">
          <h1>Deine Pets</h1>
          <Form>
            <FormCardGroup type="card">
              {Array.from(petsVm).map(([id, pet]) => (
                <PetCard to={`/pet/show/${id}`} key={id} {...pet} />))}
              <PetCard to="/pet/new/" name="Pet hinzufügen" image={Storage.get('dog')} />
            </FormCardGroup>
          </Form>
        </section>
      </div >
    );
  }
}

export default connect(
  state => ({ ...state.petsReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(Pets);




// WEBPACK FOOTER //
// ./src/pages/Pets/index.js